import * as React from 'react';

import PostType from '@research-api/utils/api/typings/PostType';

import { withExceptionCatcher } from '@/components/hoc/withExceptionCatcher';
import NewsArticlePage from '@/components/pages/news-article/layout/NewsArticlePage';
import { IComponent } from '@/types/_app';
import type { Event, ArticleType } from '@/types/ArticleType';
import { Category } from '@/utils/functions/wordpress/fetchCategories';
import CircleSpinner from '@core/components/display/spinners/CircleSpinner';

export interface NewsArticlePageControllerProps {
    article: ArticleType;
    recentResearch: PostType;
    categories: Category[];
    readMoreArticles: ArticleType[];
    upcomingEvents: Event[];
}

export const NewsArticlePageController: IComponent<any> = ({
    article,
    recentResearch,
    categories,
    readMoreArticles,
    upcomingEvents,
}: NewsArticlePageControllerProps) => {
    if (!article) {
        return (
            <div className="p-12">
                <CircleSpinner />
            </div>
        );
    }

    return (
        <NewsArticlePage
            article={article}
            recentResearch={recentResearch}
            categories={categories}
            upcomingEvents={upcomingEvents}
            readMoreArticles={readMoreArticles}
        />
    );
};

export default withExceptionCatcher(NewsArticlePageController);
